<template>
  <div>
    <div
      class="info"
      v-if="!edit && !mover && !typer"
      style="min-height: 450px;"
    >
      <controls
        v-if="canEdit"
        :question="question"
        @edit="showEdit"
        @remove="remove"
        @mover="showMove"
        @typer="showTyper"
      />

      <h4 class="question-title">
        <span v-if="question.required">*</span>
        {{ question.title }}
      </h4>

      <div class="question-body">
        <div class="question-field">
          <div class="field-placeholder">
            <youtube
              :video-id="videoId()"
              :player-vars="{ start: startTime(), rel: 0, showinfo: 0 }"
              player-width="500"
            ></youtube>
          </div>
        </div>
      </div>
    </div>

    <div class="edit" v-if="edit && !mover && !typer">
      <form @submit.prevent="onSubmit">
        <div class="field">
          <label class="label">Title</label>
          <div class="control has-icons-right mt-2">
            <input
              type="text"
              :class="['input', { 'is-danger': errors['title'] }]"
              v-model="data['title']"
              name="title"
              required
            />
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field" v-for="(field, index) in data.fields">
          <label class="label">Video</label>
          <div class="columns">
            <div class="column">
              <div class="control field-options">
                <input
                  type="url"
                  :class="['input', { 'is-danger': errors[`url${index}`] }]"
                  v-model="field['url']"
                  name="url"
                  required
                />
                <span
                  class="icon is-small is-right"
                  v-if="errors[`url${index}`]"
                  ><i class="fa fa-warning"></i
                ></span>
              </div>
              <p v-if="errors[`url${index}`]" class="help is-danger">
                {{ errors[`url${index}`] }}
              </p>
            </div>
          </div>
        </div>

        <div class="field is-grouped mt2 has-text-right">
          <div class="control">
            <button
              :class="['button', 'is-primary', { 'is-loading': loading }]"
            >
              Update
            </button>
            <button
              type="button is-link"
              class="button"
              v-on:click="hideEdit()"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>

    <question-move v-if="mover" :question="question" @hide="hideMove" />
    <question-type v-if="typer" :question="question" @hide="hideTyper" />
  </div>
</template>

<script>
import { getIdFromURL, getTimeFromURL } from "vue-youtube-embed";
import baseQuestion from "./baseQuestion";
import RoutingRules from "../routing_rules/RoutingRules";

export default {
  name: "video-instruction",

  methods: {
    videoId() {
      return getIdFromURL(this.question.fields[0].url);
    },
    startTime() {
      return getTimeFromURL(this.question.fields[0].url);
    }
  },

  mixins: [baseQuestion]
};
</script>

<style lang="scss" scoped></style>
